module.exports = __webpack_public_path__ + "static/media/logo-icon-navbar.c762d8cf.svg";